import { createFileRoute } from '@tanstack/react-router';
import { NewsletterSetupSchedule } from '@/pages/workspaces/broadcasts/newsletter/setup/schedule';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/schedule',
)({ component: withRumPageRendered(NewsletterSetupSchedule) });
